import { RefundProcessesResponse } from "@/types/refundProcess";
import { getGlobalSessionId, POST } from "@/services";

const RefundProcessServices = {
  getRefundProcesses: async () => {
    const result = await POST<RefundProcessesResponse>(
      "/refundassistant/refund-processes",
      {
        sessionId: getGlobalSessionId(),
      }
    );

    return result.data?.body || [];
  },
  getLinkedEmail: async () => {
    const result = await POST<{
      body: { email: string; provider: string }[];
    }>("/refundassistant/emails/linked");

    return result.data?.body || [];
  },
  unlinkEmail: async (email: string) => {
    const result = await POST<{
      statusCode: number;
    }>(`/refundassistant/emails/unlink`, {
      email,
      provider: "gmail",
    });

    return result.data?.statusCode || 0;
  },
};

export default RefundProcessServices;
